import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { nzTaxLink, SOLE_TRADER_PLANS } from "@/lib/conversion";

export default function PricingTeaser() {
  return (
    <section className="mt-12" data-testid="pricing-teaser">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="label-mono">/ HIRE US</div>
          <h2 className="font-display text-3xl md:text-4xl tracking-tight mt-2">
            Stop DIY-ing your tax.
          </h2>
          <p className="text-zinc-400 mt-2 text-sm max-w-xl">
            These calculators are a free sense check. Our paid service does it
            properly each month — tax position emails, GST returns, IRD on your
            behalf. Cancel any time.
          </p>
        </div>
        <a
          href={nzTaxLink("/#pricing", "dashboard-pricing")}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-ghost text-xs"
          data-testid="pricing-teaser-all-plans"
        >
          All plans + companies <ArrowRight size={14} />
        </a>
      </div>

      <div className="grid md:grid-cols-3 gap-0 mt-6 border border-[var(--border)]">
        {SOLE_TRADER_PLANS.map((p, idx) => (
          <div
            key={p.key}
            className={`p-6 md:p-7 relative flex flex-col ${
              idx > 0 ? "border-t md:border-t-0 md:border-l border-[var(--border)]" : ""
            } ${p.popular ? "bg-[var(--surface)]" : ""}`}
            data-testid={`pricing-card-${p.key}`}
          >
            {p.popular && (
              <div className="absolute -top-3 left-6 bg-[var(--primary)] text-black px-2 py-1 text-[10px] font-mono font-bold uppercase tracking-wider">
                Most popular
              </div>
            )}
            <div className="label-mono">{p.name}</div>
            <div className="mt-3 flex items-baseline gap-1">
              <span className="font-display text-4xl">${p.price}</span>
              <span className="text-xs font-mono text-zinc-500">+ GST / mo</span>
            </div>
            <p className="text-sm text-zinc-400 mt-2 min-h-[40px]">{p.blurb}</p>
            <ul className="mt-4 space-y-2 flex-1">
              {p.features.map((f) => (
                <li
                  key={f}
                  className="flex items-start gap-2 text-sm text-zinc-300"
                >
                  <Check
                    size={14}
                    className="mt-0.5 shrink-0 text-[var(--primary)]"
                  />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
            <a
              href={nzTaxLink("/#pricing", p.campaign)}
              target="_blank"
              rel="noopener noreferrer"
              className={`mt-6 ${
                p.popular ? "btn-primary" : "btn-ghost"
              } w-full justify-center text-xs`}
              data-testid={`pricing-cta-${p.key}`}
            >
              Get started
            </a>
          </div>
        ))}
      </div>

      <div className="mt-3 text-[11px] font-mono text-zinc-500 leading-relaxed">
        Pricing in NZD, GST exclusive. Companies have their own tiers — see all
        plans on nztaxation.nz.
      </div>
    </section>
  );
}
